import React, { useContext, useEffect, useState } from 'react'
import { Alert, Paper, Stack, Switch, Typography } from '@mui/material'
import moment from 'moment'
import API from '../../../services/API'
import { GlobalContext } from '../../../App'
import PermissionCheck from '../../../helpers/PermissionCheck'

const RegistrationSettings = () => {
  const { setToast } = useContext(GlobalContext)
  const [enabled, setEnabled] = useState(true)
  const [alertsSent, setAlertsSent] = useState([])
  const [loading, setLoading] = useState(true)

  const load = () => {
    setLoading(true)
    API.get('/registration/settings')
      .then((res) => {
        if (res.status === 200) {
          setEnabled(res.data.enabled)
          setAlertsSent(res.data.alertsSent || [])
        }
      })
      .catch((e) => console.log(e))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    load()
  }, [])

  const handleToggle = (e) => {
    const value = e.target.checked
    setEnabled(value)
    API.put('/registration/settings', { enabled: value }).then((res) => {
      if (res.status === 200) setToast?.({ message: `Registration Centre ${value ? 'enabled' : 'disabled'}` })
    })
  }

  return (
    <PermissionCheck roles={['Governance']} showAlert>
      <Stack gap={2}>
        <Typography variant="title1">Registration Centre Settings</Typography>

        <Paper variant="outlined" sx={{ p: 2 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack>
              <Typography variant="body2" fontWeight={600}>
                Deadline alerts
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Notifies your Governance team as the registration deadline approaches.
              </Typography>
            </Stack>
            <Switch checked={enabled} onChange={handleToggle} disabled={loading} />
          </Stack>
        </Paper>

        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="title3" sx={{ mb: 1 }}>
            Alert history
          </Typography>
          {alertsSent.length === 0 ? (
            <Alert severity="info">No deadline alerts have been sent yet.</Alert>
          ) : (
            <Stack gap={0.5}>
              {alertsSent.map((a, i) => (
                <Typography key={i} variant="body2" color="text.secondary">
                  {a.milestoneKey} - sent {moment(a.sentAt).format('Do MMM YYYY')}
                </Typography>
              ))}
            </Stack>
          )}
        </Paper>
      </Stack>
    </PermissionCheck>
  )
}

export default RegistrationSettings
